function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_4",
  x: 0,
  y: 0,
  width: 39,
  height: 39,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1382",
  "data-name": "Group 1382",
  transform: "translate(-1525.5 -584.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1316",
  "data-name": "Group 1316",
  transform: "translate(1528 587)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -2.5, -2.5)",
  filter: "url(#Ellipse_4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_4-2",
  "data-name": "Ellipse 4",
  transform: "translate(2.5 2.5)",
  fill: "#fff",
  stroke: "#e69221",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 13.5,
  fill: "none"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1234",
  "data-name": "Group 1234",
  transform: "translate(1541.636 594.955)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_48",
  "data-name": "Ellipse 48",
  cx: 1.364,
  cy: 1.364,
  r: 1.364,
  transform: "translate(0 11.364)",
  fill: "#e69221"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_799",
  "data-name": "Path 799",
  d: "M.364,0c.5,0,1.364.407,1.364.909L1.273,8.636a.909.909,0,1,1-1.818,0L-1,.909C-1,.407-.138,0,.364,0Z",
  transform: "translate(1 0)",
  fill: "#e69221"
})));

var SvgOrangeInfo = function SvgOrangeInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrangeInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/orange-info.42bf1014.svg";
export { ForwardRef as ReactComponent };